(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.PhotoCropKit = api;
})(typeof self !== 'undefined' ? self : this, function (root) {
  'use strict';

  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const inPhoto = b => b.map(v => clamp(v, 0, 1));

  function centeredBox(W, H) {
    const s = 0.7 * Math.min(W, H), x = (W - s) / 2, y = (H - s) / 2;
    return [x / W, y / H, (x + s) / W, (y + s) / H];
  }
  function cropAroundFace(b, W, H, others = []) {
    const fx = b[0] * W, fy = b[1] * H, fw = (b[2] - b[0]) * W, fh = (b[3] - b[1]) * H;
    const cx = fx + fw / 2;
    let x0 = Math.max(0, cx - fw * 1.1) / W, x1 = Math.min(W, cx + fw * 1.1) / W;
    let y0 = Math.max(0, fy - fh * 0.4) / H, y1 = Math.min(H, fy - fh * 0.4 + fh * 2.6) / H;
    others.forEach(o => {
      if (o === b || o[2] <= x0 || o[0] >= x1 || o[3] <= y0 || o[1] >= y1) return;
      if (o[1] >= b[3]) y1 = Math.min(y1, o[1]); else if (o[3] <= b[1]) y0 = Math.max(y0, o[3]);
      else if (o[0] >= b[2]) x1 = Math.min(x1, o[0]); else if (o[2] <= b[0]) x0 = Math.max(x0, o[2]);
    });
    return [x0, y0, x1, y1];
  }
  const validBox = b => Array.isArray(b) && b.length === 4 && b.every(v => isFinite(v)) && b[2] - b[0] > 0.02 && b[3] - b[1] > 0.02
    ? [clamp(+b[0], 0, 1), clamp(+b[1], 0, 1), clamp(+b[2], 0, 1), clamp(+b[3], 0, 1)] : null;

  function fitAspect(b, W, H, aspect) {
    if (!aspect) return b.slice();
    let w = (b[2] - b[0]) * W, h = (b[3] - b[1]) * H;
    if (w / h < aspect) w = h * aspect; else h = w / aspect;
    const k = Math.min(1, W / w, H / h);
    const nw = (w * k) / W, nh = (h * k) / H;
    const x0 = clamp((b[0] + b[2]) / 2 - nw / 2, 0, 1 - nw), y0 = clamp((b[1] + b[3]) / 2 - nh / 2, 0, 1 - nh);
    return inPhoto([x0, y0, x0 + nw, y0 + nh]);
  }

  function resizeBox(b0, handle, dx, dy, W, H, min, aspect) {
    const minW = min / W, minH = min / H;
    if (!aspect) {
      let [x0, y0, x1, y1] = b0;
      if (handle.includes('w')) x0 = clamp(b0[0] + dx, 0, b0[2] - minW);
      if (handle.includes('e')) x1 = clamp(b0[2] + dx, b0[0] + minW, 1);
      if (handle.includes('n')) y0 = clamp(b0[1] + dy, 0, b0[3] - minH);
      if (handle.includes('s')) y1 = clamp(b0[3] + dy, b0[1] + minH, 1);
      return [x0, y0, x1, y1];
    }
    const sx = handle.includes('e') ? 1 : -1, sy = handle.includes('s') ? 1 : -1;
    const ax = sx > 0 ? b0[0] : b0[2], ay = sy > 0 ? b0[1] : b0[3];
    const vx = sx * ((sx > 0 ? b0[2] : b0[0]) + dx - ax) * W, vy = sy * ((sy > 0 ? b0[3] : b0[1]) + dy - ay) * H;
    const most = Math.min((sx > 0 ? 1 - ax : ax) * W, (sy > 0 ? 1 - ay : ay) * H * aspect);
    const least = Math.min(Math.max(min, min * aspect), most);
    const w = clamp((vx + vy / aspect) / (1 + 1 / (aspect * aspect)), least, most);
    const nw = w / W, nh = w / aspect / H;
    const x0 = sx > 0 ? ax : ax - nw, y0 = sy > 0 ? ay : ay - nh;
    return inPhoto([x0, y0, x0 + nw, y0 + nh]);
  }

  async function decodeImage(blob) {
    if (root.createImageBitmap) {
      try { const b = await createImageBitmap(blob, { imageOrientation: 'from-image' }); return { src: b, w: b.width, h: b.height, close: () => b.close && b.close() }; }
      catch (e) {  }
    }
    const url = URL.createObjectURL(blob), img = new Image();
    img.src = url;
    try { await img.decode(); } catch (e) { URL.revokeObjectURL(url); throw e; }
    return { src: img, w: img.naturalWidth, h: img.naturalHeight, close: () => URL.revokeObjectURL(url) };
  }
  function toJpeg(src, sx, sy, sw, sh, max, q) {
    const k = Math.min(1, max / Math.max(sw, sh)), w = Math.max(1, Math.round(sw * k)), h = Math.max(1, Math.round(sh * k));
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const x = c.getContext('2d');
    x.fillStyle = '#fff'; x.fillRect(0, 0, w, h);
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(src, sx, sy, sw, sh, 0, 0, w, h);
    return new Promise((res, rej) => c.toBlob(b => (b ? res({ blob: b, w, h }) : rej(new Error('toBlob failed'))), 'image/jpeg', q));
  }
  const VIEW_MAX = 1600;

  const LABELS = {
    title: 'Crop your photo',
    sub: 'Drag the box over the part you want. Pull a corner to make it bigger or smaller.',
    ok: 'Use this crop',
    cancel: 'Cancel',
    close: 'Close',
    busy: 'Cropping…',
    finding: 'Finding faces…',
    faceHint: 'We found more than one face. Tap one to crop to it.',
    face: 'Crop to face {i}',
    box: 'Crop box. Arrow keys move it; Shift and arrow keys resize it.',
    failed: "Sorry, we couldn't crop that photo. Please try another one."
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const CSS = `
.pck [hidden]{display:none!important}
.pck{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(18,22,30,.55);font:400 15px/1.45 var(--pck-font,system-ui,sans-serif);color:var(--pck-ink,#1d2430)}
.pck-m{position:relative;width:min(560px,100%);max-height:100%;overflow:auto;box-sizing:border-box;padding:18px 18px 16px;border-radius:14px;background:var(--pck-paper,#fff);box-shadow:0 18px 50px rgba(0,0,0,.28)}
.pck-m h2{margin:0 36px 4px 0;font-family:var(--pck-heading,inherit);font-size:19px;font-weight:600;line-height:1.25}
.pck-sub{margin:0 0 12px;color:var(--pck-muted,#5b6472)}
.pck-x{position:absolute;right:10px;top:10px;width:36px;height:36px;border:0;border-radius:50%;background:transparent;color:inherit;font-size:17px;cursor:pointer}
.pck-x:hover{background:rgba(0,0,0,.06)}
.pck-cropwrap{display:flex;justify-content:center}
.pck-crop{position:relative;overflow:hidden;border-radius:10px;background:#1b1f27;touch-action:none;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;outline:none}
.pck-crop:focus-visible{box-shadow:0 0 0 3px rgba(27,52,89,.55)}
.pck-crop>img{width:100%;height:100%;display:block;pointer-events:none;-webkit-user-drag:none}
.pck-cbox{position:absolute;z-index:2;cursor:move;touch-action:none;outline:2px solid #fff;box-shadow:0 0 0 9999px rgba(18,22,30,.62)}
.pck-cbox.anim{transition:left .38s ease,top .38s ease,width .38s ease,height .38s ease}
.pck-cbox i{position:absolute;width:22px;height:22px;border:0 solid #fff}
.pck-cbox i::before{content:"";position:absolute;left:-12px;top:-12px;width:46px;height:46px}
.pck-cbox [data-h=nw]{left:-4px;top:-4px;border-width:4px 0 0 4px;cursor:nwse-resize}
.pck-cbox [data-h=ne]{right:-4px;top:-4px;border-width:4px 4px 0 0;cursor:nesw-resize}
.pck-cbox [data-h=sw]{left:-4px;bottom:-4px;border-width:0 0 4px 4px;cursor:nesw-resize}
.pck-cbox [data-h=se]{right:-4px;bottom:-4px;border-width:0 4px 4px 0;cursor:nwse-resize}
.pck-crop.drag .pck-cbox{outline-color:#b9f0b1}
.pck-faces{position:absolute;inset:0;z-index:3;pointer-events:none}
.pck-face{position:absolute;padding:0;border:2px dashed rgba(255,255,255,.8);border-radius:50%;background:rgba(255,255,255,.06);cursor:pointer;pointer-events:auto;touch-action:none}
.pck-face:hover{border-style:solid;background:rgba(255,255,255,.14)}
.pck-cfind{position:absolute;z-index:3;left:10px;top:10px;display:inline-flex;align-items:center;gap:7px;padding:7px 11px;border-radius:999px;background:rgba(255,255,255,.94);color:#1d2430;font-size:12px;font-weight:700;line-height:1}
.pck-spin{width:12px;height:12px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:pck-spin .8s linear infinite}
@keyframes pck-spin{to{transform:rotate(360deg)}}
.pck-facehint,.pck-msg{margin:10px 0 0;font-size:14px}
.pck-msg:empty{display:none}
.pck-msg.warn{color:var(--pck-warn,#8a5a00)}
.pck-msg.bad{color:var(--pck-bad,#b3261e)}
.pck-mf{display:flex;gap:10px;margin-top:14px}
.pck-btn{flex:1;min-height:46px;padding:0 14px;border:0;border-radius:10px;background:var(--pck-accent,#1b3459);color:#fff;font-family:inherit;font-size:15px;font-weight:600;line-height:1;cursor:pointer;white-space:nowrap;display:inline-flex;align-items:center;justify-content:center;gap:8px}
.pck-btn.ghost{background:transparent;color:inherit;box-shadow:inset 0 0 0 1.5px currentColor}
.pck-btn:disabled{opacity:.55;cursor:default}
html.pck-open{overflow:hidden}
@media (prefers-reduced-motion:reduce){.pck-cbox.anim{transition:none}.pck-spin{animation:none}}`;
  function addStyle() {
    if (document.getElementById('pck-style')) return;
    const s = document.createElement('style'); s.id = 'pck-style'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  let uid = 0;
  async function open(photo, options) {
    const o = options || {}, L = Object.assign({}, LABELS, o.labels || {});
    const aspect = o.aspect > 0 ? +o.aspect : 0, max = o.max || 3600, quality = o.quality || 0.9;
    const file = photo instanceof Blob ? photo : photo.blob, restore = photo instanceof Blob ? null : validBox(photo.box);

    const im = await decodeImage(file);
    let view;
    try { view = await toJpeg(im.src, 0, 0, im.w, im.h, VIEW_MAX, 0.86); } finally { im.close(); }
    const p = { w: im.w, h: im.h, view: URL.createObjectURL(view.blob), check: null };
    if (o.faces && o.detect) {
      p.checking = Promise.resolve()
        .then(() => o.detect(view.blob, { width: view.w, height: view.h, srcWidth: im.w, srcHeight: im.h }))
        .then(r => { p.check = { faces: ((r && r.faces) || []).filter(f => validBox(f && f.box)), suggested_crop: r && r.suggested_crop }; })
        .catch(err => { console.warn('[crop] face check failed; using a centered box', err); p.check = { faces: [], suggested_crop: null }; });
    }
    return new Promise(resolve => screen(p, file, restore, { o, L, aspect, max, quality }, resolve));
  }

  function screen(p, file, restore, { o, L, aspect, max, quality }, resolve) {
    addStyle();
    const id = 'pck-title-' + (++uid);
    const dlg = document.createElement('div');
    dlg.className = 'pck';
    dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', id);
    dlg.dataset.state = 'open';
    dlg.innerHTML = `<div class="pck-m">
      <button type="button" class="pck-x" aria-label="${esc(L.close)}">✕</button>
      <h2 id="${id}">${esc(L.title)}</h2>${L.sub ? `<p class="pck-sub">${esc(L.sub)}</p>` : ''}
      <div class="pck-cropwrap"><div class="pck-crop" tabindex="0" role="group" aria-label="${esc(L.box)}">
        <img src="${p.view}" alt="" draggable="false"><div class="pck-faces"></div>
        <div class="pck-cbox"><i data-h="nw"></i><i data-h="ne"></i><i data-h="sw"></i><i data-h="se"></i></div>
        <div class="pck-cfind" hidden><i class="pck-spin"></i>${esc(L.finding)}</div></div></div>
      <p class="pck-facehint" hidden>${esc(L.faceHint)}</p>
      <p class="pck-msg" aria-live="polite"></p>
      <div class="pck-mf"><button type="button" class="pck-btn ghost" data-act="cancel">${esc(L.cancel)}</button><button type="button" class="pck-btn" data-act="ok">${esc(L.ok)}</button></div>
    </div>`;
    const $ = s => dlg.querySelector(s);
    const crop = $('.pck-crop'), boxEl = $('.pck-cbox'), msg = $('.pck-msg'), ok = $('[data-act=ok]'), wrap = $('.pck-cropwrap');
    const opener = document.activeElement;
    document.body.appendChild(dlg);
    document.documentElement.classList.add('pck-open');

    let finished = false, busy = false, touched = !!restore;
    const A = p.w / p.h;
    const size = () => {
      const W = wrap.clientWidth || 300, maxH = Math.max(220, Math.min(innerHeight * 0.5, 520));
      let w = W, h = w / A; if (h > maxH) { h = maxH; w = h * A; }
      crop.style.width = Math.round(w) + 'px'; crop.style.height = Math.round(h) + 'px';
    };
    const finish = v => {
      if (finished) return; finished = true;
      removeEventListener('resize', size);
      document.removeEventListener('keydown', onKey, true);
      dlg.dataset.state = 'closed';
      dlg.remove();
      if (!document.querySelector('.pck')) document.documentElement.classList.remove('pck-open');
      URL.revokeObjectURL(p.view);
      if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
      if (v) v.box = inPhoto(v.box);
      resolve(v);
    };
    addEventListener('resize', size); size();

    const fit = b => fitAspect(b, p.w, p.h, aspect);
    let box = fit(restore || centeredBox(p.w, p.h));
    const judge = () => {
      ok.disabled = busy;
      const line = o.hint ? o.hint({ w: Math.round((box[2] - box[0]) * p.w), h: Math.round((box[3] - box[1]) * p.h) }) : '';
      msg.className = 'pck-msg' + (line ? ' warn' : '');
      msg.textContent = line || '';
    };
    const render = () => {
      const [x0, y0, x1, y1] = box;
      Object.assign(boxEl.style, { left: x0 * 100 + '%', top: y0 * 100 + '%', width: (x1 - x0) * 100 + '%', height: (y1 - y0) * 100 + '%' });
      judge();
    };
    const animateTo = b => { box = b; boxEl.classList.add('anim'); render(); setTimeout(() => boxEl.classList.remove('anim'), 420); };
    const applyCheck = () => {
      if (finished) return;
      const c = p.check || {};
      $('.pck-cfind').hidden = true;
      const faces = c.faces || [];
      if (faces.length > 1) {
        $('.pck-faces').innerHTML = faces.map((f, i) => { const [a, b, x, y] = f.box;
          return `<button type="button" class="pck-face" data-face="${i}" aria-label="${esc(L.face.replace('{i}', i + 1))}" style="left:${a * 100}%;top:${b * 100}%;width:${(x - a) * 100}%;height:${(y - b) * 100}%"></button>`; }).join('');
        $('.pck-facehint').hidden = false;
      }
      const suggested = validBox(c.suggested_crop);
      if (!touched && suggested) animateTo(fit(suggested)); else judge();
    };
    render();
    if (p.checking) { if (p.check) applyCheck(); else { $('.pck-cfind').hidden = false; p.checking.then(applyCheck); } }

    const toFace = i => { if (!p.check || !p.check.faces[i]) return; touched = true;
      animateTo(fit(cropAroundFace(p.check.faces[i].box, p.w, p.h, p.check.faces.map(x => x.box)))); };
    $('.pck-faces').addEventListener('click', e => {
      const f = e.target.closest('[data-face]'); if (!f || e.detail !== 0) return;
      toFace(+f.dataset.face);
    });

    const ptrs = new Map(); let mode = null, p0 = null, b0 = null, d0 = 0, tap = null;
    const inBox = e => { const r = crop.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      return x >= box[0] && x <= box[2] && y >= box[1] && y <= box[3]; };
    const pt = e => ({ x: e.clientX, y: e.clientY });
    const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y) || 1;
    const MIN = 44;
    const dims = () => { const W = crop.clientWidth || 1; return { W, H: W / A }; };
    const startSingle = (q, h) => { mode = h || 'move'; p0 = q; b0 = box.slice(); };
    crop.addEventListener('pointerdown', e => {
      const faceEl = e.target.closest('.pck-face');
      if (busy || (!e.target.closest('.pck-cbox') && !faceEl)) return;
      e.preventDefault();
      try { crop.setPointerCapture(e.pointerId); } catch (err) {  }
      ptrs.set(e.pointerId, pt(e)); boxEl.classList.remove('anim');
      tap = faceEl && ptrs.size === 1 ? { i: +faceEl.dataset.face, q: pt(e) } : null;
      if (ptrs.size >= 2) { const [a, b] = [...ptrs.values()]; mode = 'pinch'; d0 = dist(a, b); b0 = box.slice(); tap = null; }
      else if (faceEl && !inBox(e)) mode = null;
      else startSingle(pt(e), faceEl ? undefined : e.target.dataset.h);
      if (!faceEl) touched = true;
      if (mode) crop.classList.add('drag');
    });
    crop.addEventListener('pointermove', e => {
      if (!ptrs.has(e.pointerId)) return;
      ptrs.set(e.pointerId, pt(e));
      if (tap && dist(tap.q, pt(e)) > 6) tap = null;
      if (!mode || tap) return;
      touched = true;
      const { W, H } = dims();
      const [x0, y0, x1, y1] = b0;
      if (mode === 'pinch') {
        const [a, b] = [...ptrs.values()], bw = x1 - x0, bh = y1 - y0;
        const k = clamp(dist(a, b) / d0, Math.max(MIN / W / bw, MIN / H / bh), Math.min(1 / bw, 1 / bh));
        const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2, w = bw * k, h = bh * k;
        const nx = clamp(cx - w / 2, 0, 1 - w), ny = clamp(cy - h / 2, 0, 1 - h);
        box = [nx, ny, nx + w, ny + h];
      } else {
        const q = pt(e), dx = (q.x - p0.x) / W, dy = (q.y - p0.y) / H;
        if (mode === 'move') {
          const w = x1 - x0, h = y1 - y0, nx = clamp(x0 + dx, 0, 1 - w), ny = clamp(y0 + dy, 0, 1 - h);
          box = [nx, ny, nx + w, ny + h];
        } else box = resizeBox(b0, mode, dx, dy, W, H, MIN, aspect);
      }
      render();
    });
    const up = e => {
      if (!ptrs.delete(e.pointerId)) return;
      if (tap && e.type === 'pointerup' && !ptrs.size) { const i = tap.i; tap = null; mode = null; crop.classList.remove('drag'); toFace(i); return; }
      tap = null;
      if (ptrs.size === 1) startSingle([...ptrs.values()][0], 'move');
      else if (!ptrs.size) { mode = null; crop.classList.remove('drag'); }
    };
    crop.addEventListener('pointerup', up); crop.addEventListener('pointercancel', up);
    crop.addEventListener('keydown', e => {
      const d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key]; if (!d || busy) return;
      e.preventDefault(); touched = true;
      const s = 0.015, [x0, y0, x1, y1] = box, { W, H } = dims();
      if (e.shiftKey) box = resizeBox(box, 'se', d[0] * s, d[1] * s, W, H, MIN, aspect);
      else { const w = x1 - x0, h = y1 - y0, nx = clamp(x0 + d[0] * s, 0, 1 - w), ny = clamp(y0 + d[1] * s, 0, 1 - h); box = [nx, ny, nx + w, ny + h]; }
      render();
    });

    function onKey(e) {
      if (finished || dlg !== [...document.querySelectorAll('.pck')].pop()) return;
      if (e.key === 'Escape') { if (e.defaultPrevented) return; e.preventDefault(); if (!busy) finish(null); return; }
      if (e.key !== 'Tab') return;
      const f = [...dlg.querySelectorAll('button:not([disabled]):not([hidden]), [tabindex="0"]')].filter(x => x.getClientRects().length);
      if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      if (i === -1) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
      else if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
    document.addEventListener('keydown', onKey, true);
    dlg.addEventListener('mousedown', e => { if (e.target === dlg) e.preventDefault(); });
    $('.pck-x').onclick = () => { if (!busy) finish(null); };
    $('[data-act=cancel]').onclick = () => { if (!busy) finish(null); };
    ok.onclick = async () => {
      busy = true; ok.disabled = true; ok.innerHTML = `<i class="pck-spin"></i> ${esc(L.busy)}`;
      try {
        const im = await decodeImage(file);
        try {
          const sx = Math.round(box[0] * im.w), sy = Math.round(box[1] * im.h);
          const sw = Math.max(1, Math.round((box[2] - box[0]) * im.w)), sh = Math.max(1, Math.round((box[3] - box[1]) * im.h));
          const out = await toJpeg(im.src, sx, sy, sw, sh, max, quality);
          finish({ box: box.slice(), blob: out.blob, w: out.w, h: out.h });
        } finally { im.close(); }
      } catch (err) {
        console.error('[crop] crop failed', err); busy = false; ok.textContent = L.ok; judge();
        msg.className = 'pck-msg bad'; msg.textContent = L.failed;
      }
    };
    crop.focus({ preventScroll: true });
  }

  return {
    open, LABELS,
    decodeImage, toJpeg, validBox, centeredBox, cropAroundFace, fitAspect, resizeBox
  };
});
